import {BasketProvider} from "@shared/models/basket-provider";
import {DialogModel} from "@shared/models/dialog.model";
import {CommandService} from "@core/services/command.service";
import {DialogService} from "@shared/services/dialog-service";
import {InstanceLoader} from "@shared/helpers/dynamic-class-helper";
import {takeUntil} from "rxjs/operators";
import {
  CreateMonthlyFilingCommand, CreateOtherFilingCommand,
  CreateQuarterlyFilingCommand, CreateYearlyFilingCommand
} from "../../commands/dac6-reporter.command";
import {Router} from "@angular/router";
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
/**
 * Created by shakibuz.zaman on 1/14/2021.
 */
export const basketDueDateKeyMapping = {
  'dac6-eu': [{key: 'CountryToReport', header: 'Country to Report'},{key: 'ReportingEntity', header: 'Reporting Entity'},{key: 'ReportingDueDate', header: 'Reporting Due Date'}],
  'dac6-mx': [{key: 'ReportingEntity', header: 'Reporting Entity'},{key: 'ReportingDueDate', header: 'Reporting Due Date'}],
  'dac6-gb': [{key: 'ReportingEntity', header: 'Reporting Entity'},{key: 'ReportingDueDate', header: 'Reporting Due Date'}]
}
export class ArrangementBasketHelper {
  static isCreateDueDateValid(item: any): boolean{
    const currentBasketId = BasketProvider.getCurrentBasket().id;
    const dueDateRequierdFields = basketDueDateKeyMapping[currentBasketId];
    let isValid = true;
    dueDateRequierdFields.forEach(field=>{
      if(!item.cells[field.key]){
        isValid = false;
      }
    })
    return isValid;
  }
  static dueDateCreationInvalidMessage(){
    const currentBasketId = BasketProvider.getCurrentBasket().id;
    const dueDateRequierdFields = basketDueDateKeyMapping[currentBasketId];
    const joinedFieldHeader = dueDateRequierdFields.map(item=>item.header).join(', ');
    return `${joinedFieldHeader} are mandatory fields to create Due Date.`;
  }
  static createFilinngStepper(metaData: any, router: Router, commandService: CommandService, dialogService: DialogService, fuseSplashScreenService: FuseSplashScreenService){
    const currentBasketId = BasketProvider.getCurrentBasket().id;
    const startPoint = createFilingNextActionConfig[currentBasketId].Root;
    const activity  = InstanceLoader.getInstance<ICreateFilingAction>(ArrangementDyanamicClasses, startPoint, router, commandService, dialogService, fuseSplashScreenService, metaData);
    activity.doExecute();
  }
}
export const createFilingNextActionConfig = {
  'dac6-eu': {
    'Root': 'SelectVersionActivity',
    'SelectVersionActivity': 'SelectCassActivity',
    'SelectCassActivity': 'SelectMarketableCassActivity',
    'SelectMarketableCassActivity': 'CreateFilingActivity'
  },
  'dac6-mx':{
    'Root': 'SelectVersionActivity',
    'SelectVersionActivity': 'SelectCassActivity',
    'SelectCassActivity': 'CreateFilingActivity'
  },
  'dac6-gb': {
    'Root': 'SelectVersionActivity',
    'SelectVersionActivity': 'SelectCassActivity',
    'SelectCassActivity': 'CreateFilingActivity'
  }
}
export interface ICreateFilingAction{
  dialogModel: DialogModel;
  onCancel();
  onDone();
  doExecute();
}

export namespace ArrangementDyanamicClasses{
  export class SelectVersionActivity implements ICreateFilingAction{
    dialogModel: DialogModel;
    constructor(public router: Router, public commandService: CommandService, private dialogService: DialogService, private fuseSplashScreenService, private metaData: any){
      let arrangementData = {};
      if(this.metaData && this.metaData.arrangement && this.metaData.arrangement.cells){
        arrangementData = this.metaData.arrangement.cells;
      }
      this.dialogModel = DialogModel.create('Create Filing',
        'CreateFilingDialogComponent',
        {'fromArrangement': true, 'arrangementData': arrangementData}, '600px', '700px', true);
      this.dialogModel.okCaption = 'Next';
    }
    doExecute(){
      this.dialogService.showOkCancelDialog(this.dialogModel)
        .subscribe(actionState => {
          if (actionState && actionState.action === 'OK') {
            if(actionState.data && actionState.data.input && actionState.data.input.formVersionData){
              this.metaData['formVersionData'] = actionState.data.input.formVersionData;
            }
            this.onDone();
          }
        })
    }
    onCancel() {
    }

    onDone() {
      const currentBasketId = BasketProvider.getCurrentBasket().id;
      if(createFilingNextActionConfig[currentBasketId]['SelectVersionActivity']){
        const nextActivity = InstanceLoader.getInstance<ICreateFilingAction>(ArrangementDyanamicClasses, createFilingNextActionConfig[currentBasketId]['SelectVersionActivity'], this.router, this.commandService, this.dialogService, this.fuseSplashScreenService, this.metaData);
        nextActivity.doExecute();
      }
    }

  }
  export class SelectCassActivity implements ICreateFilingAction{
    dialogModel: DialogModel;
    constructor(public router: Router, public commandService: CommandService, private dialogService: DialogService, private fuseSplashScreenService, private metaData: any){
      const input = {
        ['SELECTION_KEY']: this.metaData['selectionKey'],
        ['ITEM_ACTION_ID']: this.metaData['actionId']
      };
      this.dialogModel = DialogModel.create('Select arrangement to create filing', 'EntitySelectorDialogComponent', {
        filterId: this.metaData['arrangement'].id,
        filterTemplateId: 'dac6-create-filing-from-arrangement-filter',
        apiKey: 'Dac6Api',
        message: `Note: To create filing record(s), please select from the available Cases listed below and click 'Done'. The Case you chose initially has already been selected. If you can't see certain Cases here, it may be because you haven't yet provided the mandatory Country to Report, Reporting Entity and Reporting Date information via the Arrangements screen.`,
        input: input
      });
      this.dialogModel.isFullscreen = true;
      if (this.metaData['filingType'] === 'monthly') {
        this.dialogModel.okCaption = 'Next';
      }
    }
    doExecute(){
      this.dialogService.showOkCancelDialog(this.dialogModel)
        .subscribe(actionState => {
          if (actionState && actionState.action === 'OK') {
            this.onDone();
          }
        })
    }
    onCancel() {
    }

    onDone() {
      if(this.metaData['filingType'] === 'monthly'){
        const currentBasketId = BasketProvider.getCurrentBasket().id;
        if(createFilingNextActionConfig[currentBasketId]['SelectCassActivity']){
          const nextActivity = InstanceLoader.getInstance<ICreateFilingAction>(ArrangementDyanamicClasses, createFilingNextActionConfig[currentBasketId]['SelectCassActivity'], this.router, this.commandService, this.dialogService, this.fuseSplashScreenService, this.metaData);
          nextActivity.doExecute();
        }
      }
      else if(this.metaData['filingType'] === 'quarterly') {
        var command = new CreateQuarterlyFilingCommand(this.metaData['arrangement'].id, this.metaData['formVersionData'].reportingCountryCode, this.metaData['formVersionData'].formTemplateId, this.metaData['formVersionData'].category);
        this.commandService.executeCommand(command).subscribe(state => {
          if (state) {
            this.router.navigateByUrl(`dac6-reporter/filing/${this.metaData['filingType']}`);
          }
        });
      }
      else if(this.metaData['filingType'] === 'other') {
        var command = new CreateOtherFilingCommand(this.metaData['arrangement'].id, this.metaData['formVersionData'].reportingCountryCode, this.metaData['formVersionData'].formTemplateId, this.metaData['formVersionData'].category);
        this.commandService.executeCommand(command).subscribe(state => {
          if (state) {
            this.router.navigateByUrl(`dac6-reporter/filing/${this.metaData['filingType']}`);
          }
        });
      }
    }

  }
  export class SelectMarketableCassActivity implements ICreateFilingAction{
    dialogModel: DialogModel;
    constructor(public router: Router, public commandService: CommandService, private dialogService: DialogService, private fuseSplashScreenService, private metaData: any){
      let marketebleSelectionKey = 'marked-marketable-arrangement';
      this.dialogModel = DialogModel.create('Select marketable arrangements', 'EntitySelectorDialogComponent', {
        filterId: this.metaData['arrangement'].id,
        filterTemplateId: 'dac6-select-marketable-arrangement-filter',
        apiKey: 'Dac6Api',
        message: `Note: The selected case(s) will automatically be added to the quarterly reporting tabs.`,
        input: {
          ['SELECTION_KEY']: marketebleSelectionKey,
          ['OLD_FILTER']: this.metaData['arrangement'].id,
          ['OLD_SELECTION']: this.metaData['selectionKey']
        }
      });
      this.dialogModel.isFullscreen = true;
    }
    doExecute(){
      this.dialogService.showOkCancelDialog(this.dialogModel)
        .subscribe(actionState => {
          if (actionState && actionState.action === 'OK') {
            this.onDone();
          }
        });
    }
    onCancel() {
    }

    onDone() {
      const currentBasketId = BasketProvider.getCurrentBasket().id;
      if(createFilingNextActionConfig[currentBasketId]['SelectMarketableCassActivity']){
        const nextActivity = InstanceLoader.getInstance<ICreateFilingAction>(ArrangementDyanamicClasses, createFilingNextActionConfig[currentBasketId]['SelectMarketableCassActivity'], this.router, this.commandService, this.dialogService, this.fuseSplashScreenService, this.metaData);
        nextActivity.doExecute();
      }

    }

  }
  export class CreateFilingActivity implements ICreateFilingAction{
    dialogModel: DialogModel;
    constructor(public router: Router, public commandService: CommandService, private dialogService: DialogService, private fuseSplashScreenService, private metaData: any){
    }
    doExecute(){
      this.fuseSplashScreenService.show();
      var command = new CreateMonthlyFilingCommand(this.metaData['arrangement'].id, this.metaData['formVersionData'].reportingCountryCode, this.metaData['formVersionData'].formTemplateId, this.metaData['formVersionData'].category);
      this.commandService.executeCommand(command).subscribe(state => {
        this.fuseSplashScreenService.hide();
        if (state) {
          this.router.navigateByUrl(`dac6-reporter/filing/${this.metaData['filingType']}`);
        }
      }, error => {
        console.log(error);
        this.fuseSplashScreenService.hide();
      });
    }
    onCancel() {
    }

    onDone() {
    }

  }
}

